import { useState, useEffect, useContext } from "react";

import Address, { UserAddress } from "../models/address";
import { Paginate } from "../models/paginate";

import { getUserAddresses } from "api/address";
import { useGetAddressesApi } from "hooks/api";
import { AuthContext } from "providers/CognitoAuthProvider";

export const useSuggestedAddresses = (
  workplaceName: string,
  page: number | null
): Paginate<Address> => {
  const [suggestedAddresses, setSuggestedAddresses] = useState<
    Paginate<Address>
  >({
    datas: [],
    totalPages: 0,
    totalCount: 0,
    currentPage: 0,
  });
  const getAddressesApi = useGetAddressesApi();

  useEffect(() => {
    (async () => {
      const addresses = await (function fetch(_workplaceName, _page) {
        if (_workplaceName === "") {
          return {
            datas: [],
            currentPage: 0,
            totalPages: 0,
            totalCount: 0,
          };
        }
        return getAddressesApi(_workplaceName, _page);
      })(workplaceName, page);

      setSuggestedAddresses(addresses);
    })();
  }, [getAddressesApi, workplaceName, page]);

  return suggestedAddresses;
};

export const useUserAddresses = (): UserAddress[] => {
  const auth = useContext(AuthContext);
  const [userAddresses, setUserAddresses] = useState<UserAddress[]>([]);

  useEffect(() => {
    (async () => {
      const data = await getUserAddresses(auth);
      setUserAddresses(data);
    })();
  }, [auth]);

  return userAddresses;
};
